export class SubscriptionNotEligibleError extends Error {
  constructor() {
    super('Products are not eligible for a subscription')
    this.name = 'SubscriptionNotEligibleError'
  }
}
